//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import cx from 'classnames';

import ShowWhiteSpaceChars from 'components/ShowWhiteSpaceChars';
import { tNamespaced } from 'utils/i18nUtil';
import { parseFuzzyValue } from '../FuzzySelect/utils/fuzzyValueHelpers';

import './ConditionReadOnly.less';

const tsf = tNamespaced('SimpleFilter');

interface ConditionReadOnlyProps {
  left?: string;
  operator?: string;
  right?: string | React.ReactNode;
  className?: string;
  /* try to let the backend set our label before we use local translations */
  operatorLabel?: string;
}

const getOperatorDisplay = (operator: string | undefined, operatorLabel: string | undefined): string => {
  if (operatorLabel) {
    return operatorLabel.toLowerCase();
  }

  if (!operator) {
    return '';
  }

  // Parse potential fuzzy operator (e.g., "resembles:70" -> "resembles")
  const { value: baseOperator } = parseFuzzyValue(operator);

  return tsf(baseOperator).toLowerCase();
};

const ConditionReadOnly = ({ left, operator, operatorLabel, right, className }: ConditionReadOnlyProps) => {
  // Show empty state if all values are missing
  if (!left && !operator && !right) {
    return <span>{tsf('empty_filter')}</span>;
  }

  const operatorText = getOperatorDisplay(operator, operatorLabel);

  return (
    <span className={cx('synri-condition-readonly', className)}>
      <span className="synri-left-value">{left}</span>
      <span> {operatorText} </span>
      <span className="synri-right-value">
        <ShowWhiteSpaceChars>{right}</ShowWhiteSpaceChars>
      </span>
    </span>
  );
};

export default ConditionReadOnly;
